import {compositeDisposable, IDisposable} from "../utils/disposable";
import {expressEventListener, expressQuerySelector, expressQuerySelectorAll, expressRemoveClass} from "../common/html";
import {createReviewBar} from "../components/review-bar";


export interface ICreateReviewBarsDependencies {
    readonly onClick: (stars: number) => void;
}

export function createReviewBars(containerEl: HTMLElement, dependencies: ICreateReviewBarsDependencies) {

    let eventDisposable: IDisposable;
    const {onClick} = dependencies;

    const reviewBarEls = expressQuerySelectorAll<HTMLElement>(containerEl, '.m-review-bars__review-link, .m-review-bars__review-no-link');
    const reviewBarComponents: { dispose: () => void; update: (totalNumberOfReviews: number, amount: number) => void; startValue: number }[] = [];
    const reviewBarsTotalLinkEl = expressQuerySelector<HTMLElement>(containerEl, '.m-review-bars__reviews-link', true);

    const clearActiveBar = () => reviewBarEls.forEach(el => expressRemoveClass(el, 'm-review-bars__review-link--active'));

    const deinit = () => eventDisposable && eventDisposable.dispose();

    const updateAmounts = (totalReviews: number, starAmounts: { key: number, value: number }[], resetActiveBar = false) => {
        const replaceAmountBetweenParentheses = (text: string, amount: string): string => {
            return text.replace(/ \([0-9]*?\)/g, ' (' + amount + ')');
        };

        if (resetActiveBar) clearActiveBar();

        reviewBarComponents.forEach(barcomponent => {
            const reviewStar = starAmounts.find(x => x.key === barcomponent.startValue);
            barcomponent.update(totalReviews, !reviewStar ? 0 : reviewStar.value); // no reviews for star ? => reset
        });

        const innerTextEl = expressQuerySelector(reviewBarsTotalLinkEl, 'span', true);
        innerTextEl.innerText = replaceAmountBetweenParentheses(innerTextEl.innerText, totalReviews + "");
    };

    const init = () => {
        deinit();

        reviewBarEls.forEach(el => {
            reviewBarComponents.push(createReviewBar(el, {onClick, clearActiveBar}));
        });

        eventDisposable = compositeDisposable(
            [
                expressEventListener(reviewBarsTotalLinkEl, "click", () => {
                    onClick(0);
                    clearActiveBar();
                }),
            ]
        );
    };
    const dispose = () => {
        deinit();
    };

    init();

    return {
        dispose,
        updateAmounts
    };
}
